export const getBaseActivityType = (activityType: string | null) => {
  if (activityType?.toLowerCase().includes('running')) {
    return 'running'
  } else if (activityType?.toLowerCase().includes('cycling') || activityType?.toLowerCase().includes('biking')) {
    return 'cycling'
  } else if (activityType?.toLowerCase().includes('swimming')) {
    return 'swimming'
  } else if (
    activityType?.toLowerCase().includes('cross_country_skiing') ||
    activityType?.toLowerCase().includes('skate_skiing')
  ) {
    return 'cross_country_skiing'
  } else {
    return activityType ?? 'unknown'
  }
}
